<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">{{ title }}</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
        <b-col lg="6" cols="5" class="text-right">
          <base-button size="sm" type="neutral" @click="cancel">Cancel</base-button>
          <base-button size="sm" type="neutral" @click="openCommentsModal" v-if="$route.params.id">
            <span class="btn-inner--icon"><i class="fas fa-sticky-note"></i></span>
              <span class="btn-inner--text">Notes</span>
          </base-button>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <validation-observer v-slot="{ invalid }" ref="formValidator">
        <form class="needs-validation" ref="pipelineForm"
              @submit.prevent="submit">
          <b-row>
            <b-col md="4" class="pt-6">
              <h4>Contract Information</h4>
            </b-col>
            <b-col md="8">
              <b-card no-body>
                <b-card-header>
                  <b-dropdown id="how-to-dropdown" text="How To Videos" variant="outline-danger" size="sm" class="float-right">
                    <b-dropdown-item><b-link href="#" @click="startHowTo('740859542?h=debce2d720', 'Price')">Price</b-link></b-dropdown-item>
                  </b-dropdown>
                </b-card-header>
                <b-card-body>
                  <base-input label="Date of Initial Contact:" label-for="date">
                    <b-form-datepicker v-model="form.date" required placeholder="Choose a date" local="en"></b-form-datepicker>
                  </base-input>

                  <base-input label="Type:" label-for="type">
                    <el-select v-model="form.type" required>
                      <el-option value="listing" label="Listing"></el-option>
                      <el-option value="buyer" label="Buyer"></el-option>
                    </el-select>
                  </base-input>

                  <base-input type="number"
                              step="0.01"
                              min="0"
                              input-group-classes="input-group-merge"
                              prependIcon="fas fa-dollar-sign"
                              label="Price:"
                              label-for="price"
                              name="Price"
                              :rules="{required: true, min_value: 1}"
                              v-model="form.price">
                  </base-input>

                  <b-row>
                    <b-col>
                      <base-input type="number"
                                  step="0.01"
                                  min="0"
                                  input-group-classes="input-group-merge"
                                  appendIcon="fas fa-percent"
                                  label="Commission %:"
                                  label-for="commission"
                                  name="Commission %"
                                  :rules="{required: true, min_value: 0.01}"
                                  v-model="form.commission">
                      </base-input>
                    </b-col>
                    <b-col>
                      <div class="mt-5">
                        <strong>Potential Commission:</strong> {{ form.price * (form.commission / 100) | currency }}
                      </div>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col>
                      <base-input type="number"
                                  step="0.01"
                                  min="0"
                                  input-group-classes="input-group-merge"
                                  appendIcon="fas fa-percent"
                                  label="What split percentage will you make on this sale?"
                                  label-for="cos"
                                  name="What split percentage will you make on this sale?"
                                  :rules="{required: true, min_value: 0.01}"
                                  v-model="form.cos">
                      </base-input>
                    </b-col>
                    <b-col>
                      <div class="mt-5">
                        <strong>Potential Profit:</strong> {{ (form.price * (form.commission / 100) * (form.cos / 100)) | currency }}
                      </div>
                    </b-col>
                  </b-row>

                  <base-input label="Primary Source">
                    <el-select v-model="form.primary_source"
                               filterable
                               placeholder="Type or Select Source">
                      <el-option v-for="(source, key) in primarySources"
                                 :key="source"
                                 :label="source"
                                 :value="source">
                      </el-option>
                    </el-select>
                  </base-input>

                  <base-input label="Source Description" v-if="form.primary_source == 'Database'">
                    <el-select v-model="form.source"
                               filterable
                               allow-create
                               placeholder="i.e. Past Client, SOI, Vendor Referral">
                      <el-option v-for="(source, key) in sources"
                                 :key="source"
                                 :label="source"
                                 :value="source">
                      </el-option>
                    </el-select>
                  </base-input>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="4">
              <h4>Client Information</h4>
              <b-button v-b-modal.fub-people-search :userRoute="userRoute" v-if="fubIntegration"><img src="/img/integrations/fub-icon.png" style="height: 0.875rem; margin-right: 5px; vertical-align: unset;" /> Search FUB</b-button>
            </b-col>
            <b-col md="8">
              <b-card no-body>
                <b-card-body>
                  <base-input label="Name:"
                              label-for="name"
                              name="Name"
                              v-model="form.client.name"
                              :rules="{required: true}">
                  </base-input>

                  <base-input type="tel"
                              label="Phone:"
                              label-for="name"
                              name="Phone"
                              v-model="form.client.phone"
                              :rules="{required: true}">
                  </base-input>

                  <base-input label="Email:"
                              label-for="email"
                              name="Email"
                              v-model="form.client.email"
                              rules="email">
                  </base-input>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="4">
              <h4>Property Information</h4>
            </b-col>
            <b-col md="8">
              <b-card no-body>
                <b-card-body>
                  <base-input label="Address:"
                              label-for="name"
                              name="Address"
                              v-model="form.property.address"
                              :rules="{required: listingPipeline}">
                  </base-input>

                  <base-input label="City:"
                              label-for="city"
                              name="City"
                              v-model="form.property.city"
                              :rules="{required: listingPipeline}">
                  </base-input>

                  <base-input label="State:"
                              label-for="name"
                              name="State"
                              v-model="form.property.state"
                              :rules="{required: listingPipeline}">
                  </base-input>

                  <base-input label="Zipcode:"
                              label-for="name"
                              name="Zipcode"
                              v-model="form.property.zipcode"
                              :rules="{required: listingPipeline}">
                  </base-input>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="4">
              <h4>Pipeline Information</h4>
            </b-col>
            <b-col md="8">
              <b-card no-body>
                <b-card-header>
                  <b-dropdown id="how-to-dropdown" text="How To Videos" variant="outline-danger" size="sm" class="float-right">
                    <b-dropdown-item><b-link href="#" @click="startHowTo('740859561?h=0ce28abadc', 'Pipeline Rating')">Pipeline Rating</b-link></b-dropdown-item>
                    <b-dropdown-item><b-link href="#" @click="startHowTo('740859532?h=a3a84fa368', 'Status')">Status</b-link></b-dropdown-item>
                  </b-dropdown>
                </b-card-header>
                <b-card-body>
                  <base-input label="Status:" label-for="status" name="Status" :rules="{required: true}">
                    <el-select v-model="form.status">
                      <el-option :value="null" selected>Select a Status</el-option>
                      <el-option value="Nurture" label="Nurture"></el-option>
                      <el-option value="Appt Set" label="Appt Set"></el-option>
                      <el-option value="Appt Held" label="Appt Held"></el-option>
                      <el-option value="Agreement Signed" label="Agreement Signed" v-if="form.type == 'buyer'"></el-option>
                      <el-option value="Listing Taken" label="Listing Taken" v-if="form.type == 'listing'"></el-option>
                      <el-option value="Sold" label="Sold"></el-option>
                      <el-option value="Out" label="Out"></el-option>
                    </el-select>
                  </base-input>

                  <label class="form-control-label">Pipeline Rating</label> <span variant="default" id="popover-button-variant-default" tabindex="0"><i class="fas fa-question-circle"></i></span>
                  <b-popover target="popover-button-variant-default" variant="default" triggers="hover" placement="top">
                    <b-list-group v-if="form.type == 'listing'" class="text-left">
                      <b-list-group-item>10 - Signing listing paperwork THIS MONTH</b-list-group-item>
                      <b-list-group-item>9 - Signing listing paperwork NEXT MONTH</b-list-group-item>
                      <b-list-group-item>8 - Signing listing paperwork IN 2 MONTHS</b-list-group-item>
                      <b-list-group-item>7 - Signing listing paperwork IN 3 MONTHS</b-list-group-item>
                      <b-list-group-item>6 - Signing listing paperwork IN 4 MONTHS</b-list-group-item>
                      <b-list-group-item>5 - Signing listing paperwork IN 5+ MONTHS</b-list-group-item>
                    </b-list-group>
                    <b-list-group v-else>
                      <b-list-group-item>10 - Purchasing a home THIS MONTH</b-list-group-item>
                      <b-list-group-item>9 - Purchasing a home NEXT MONTH</b-list-group-item>
                      <b-list-group-item>8 - Purchasing a home IN 2 MONTHS</b-list-group-item>
                      <b-list-group-item>7 - Purchasing a home IN 3 MONTHS</b-list-group-item>
                      <b-list-group-item>6 - Purchasing a home IN 4 MONTHS</b-list-group-item>
                      <b-list-group-item>5 - Purchasing a home IN 5+ MONTHS</b-list-group-item>
                    </b-list-group>
                  </b-popover>
                  <base-input type="number"
                              min="5"
                              max="10"
                              label-for="type"
                              v-model="form.pipeline_rating">
                  </base-input>

                  <base-checkbox class="mb-3" v-model="form.follow_up">
                      Would you like a follow up reminder?
                  </base-checkbox>

                  <base-input label="Follow Up Date:" label-for="date" v-if="form.follow_up">
                    <b-form-datepicker v-model="form.follow_up_date" required placeholder="Choose a date" local="en"></b-form-datepicker>
                  </base-input>

                  <ul v-if="errorList" class="text-danger">
                    <li v-for="(error, index) in errorList" :key="index">{{ error }}</li>
                  </ul>

                  <base-button block type="success" native-type="submit">Submit</base-button>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </form>
      </validation-observer>
    </b-container>
    <how-to-modal :source="howToVideo" :video_title="howToTitle"></how-to-modal>
    <comments-modal :type="'pipelines'"
                 :typeId="$route.params.id"
                 :userRoute="userRoute">
    </comments-modal>
    <fub-people-search :userRoute="userRoute" @addClient="addClient" v-if="fubIntegration"></fub-people-search>
    <address-select :person="person" @fillAddress="fillAddress" v-if="fubIntegration"></address-select>
  </div>
</template>

<script>
import axios from 'axios';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import {Select, OptionGroup, Option} from 'element-ui';
import initialState from './FormData/pipelineFormData';
import errorsMixin from '@/mixins/errors-mixin';
import sourcesMixin from '@/mixins/sources-mixin';
import HowToModal from '@/views/Components/Modals/HowToModal';
import CommentsModal from '@/views/Components/Modals/CommentsModal';
import FubPeopleSearch from '@/views/Components/Modals/FubPeopleSearch';
import AddressSelect from '@/views/Components/FUB/AddressSelect';

export default {
  mixins: [errorsMixin, sourcesMixin],
  components: {
    RouteBreadCrumb,
    [Select.name]: Select,
    [OptionGroup.name]: OptionGroup,
    [Option.name]: Option,
    HowToModal,
    CommentsModal,
    FubPeopleSearch,
    AddressSelect
  },
  props: {
    pipeline: null,
  },
  data() {
    return initialState();
  },
  computed: {
    backRoute() {
      if(this.$route.params.user) {
        return "/observatory/" + this.$route.params.user + "/pipelines";
      }
      return "/pipelines";
    },
    userRoute() {
      if(this.$route.params.user) {
        return process.env.VUE_APP_API_BASE_URL + "/users/" + this.$route.params.user;
      }
      return this.$store.getters['profile/userRoute'];
    },
    title() {
      return this.pipeline ? 'Edit Pipeline' : 'New Pipeline';
    },
    listingPipeline() {
      return this.form.type == 'listing';
    },
    integrations() {
      if(this.$route.params.user) {
        return this.$store.getters['observed/observed'].integrations;
      }
      return this.$store.getters['profile/user'].integrations;
    },
    fubIntegration() {
      return this.integrations.includes('follow-up-boss');
    }
  },
  methods: {
    async getClients() {
      axios.get(this.userRoute + "/clients")
        .then(response => {
          this.clients = response.data;
        })
        .catch(error => {
          this.error(error)
        });
    },
    async getPipeline() {
      axios.get(this.userRoute + "/pipelines/" + this.$route.params.id)
      .then(response => {
        this.form = response.data;
      })
      .catch(error => {
        this.error(error);
      });
    },
    async submit() {
      this.errorList = null;
      const isValid = await this.$refs.formValidator.validate();

      if(!isValid) {
        this.errorList = Object.values(this.$refs.formValidator.errors).flat();
      } else {
        if(this.form.id) {
          this.update();
        } else {
          this.add();
        }
      }
    },
    async add() {
      this.form.user_slug = this.user_slug;
      
      axios.post(this.userRoute + "/pipelines", this.form)
        .then(response => {
          swal.fire({
            title: `Success`,
            text: response.data,
            showConfirmButton: false,
            timer: 1750,
            icon: 'success'
          }).then(result => {
            Object.assign(this.$data, initialState());
            this.$refs.formValidator.reset();
            this.$router.push({
              path: this.backRoute,
              query: this.$route.query
            });
          });
        })
        .catch(error => {
          this.error(error);
        });
    },
    async update() {
      axios.patch(this.userRoute + "/pipelines/" + this.form.id, this.form)
        .then(response => {
          swal.fire({
            title: `Success`,
            text: response.data,
            showConfirmButton: false,
            timer: 1750,
            icon: 'success'
          }).then(result => {
            Object.assign(this.$data, initialState());
            this.$refs.formValidator.reset();
            this.$router.push({
              path: this.backRoute,
              query: this.$route.query
            });
          });
        })
        .catch(error => {
          this.error(error);
        });
    },
    cancel() {
      Object.assign(this.$data, initialState());
      this.$router.push({
        path: this.backRoute,
        query: this.$route.query
      });
    },
    startHowTo(video, title) {
      this.howToVideo = video;
      this.howToTitle = title;
      this.$bvModal.show('how-to-modal');
    },
    openCommentsModal() {
      this.$bvModal.show('comments-modal');
    },
    addClient(client) {
      this.form.client.name = client.name;
      this.form.client.phone = client.phones[0].value;
      this.form.client.email = client.emails[0].value;
    },
    getPerson() {
      axios.get(this.userRoute + "/integrations/fub/people/person?personId=" + this.$route.query.person)
      .then(response => {
        this.person = response.data;
        this.fillPerson(response.data);
      })
      .catch(error => {
        // error
      });
    },
    fillPerson(attributes) {
      this.form.price = attributes.price;
      this.form.client.name = attributes.name;
      this.form.client.phone = attributes.phones.length > 0 ? attributes.phones[0].value : null;
      this.form.client.email = attributes.emails.length > 0 ? attributes.emails[0].value : null;
      this.$bvModal.show('address-modal');
    },
    fillAddress(address) {
      this.form.property.address = address.street;
      this.form.property.city = address.city;
      this.form.property.state = address.state;
      this.form.property.zipcode = address.code;
      this.$bvModal.hide('address-modal');
    }
  },
  created() {
    this.getClients();
    if (this.$route.params.id) {
      this.getPipeline();
    }

    if (this.$route.query.person) {
      this.getPerson();
    }
  }
}
</script>